import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { API_BIS_PATENT_FETCH_WIPS_DETAILS, API_WIPS_SYNC_PROGRESS } from "@/configs/Apis";
import { showSuccess, showWarning } from "@/utils/UI";
import DuduAjax from "@/utils/DuduAjax";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentLinks',
  props: {
  patent: { required: true, default: () => ({}), type: Object },
},
  emits: ["refresh"],
  setup(__props, { emit }) {

const props = __props;




const store = useStore();

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

function pollDetailProgress(requestUuid: string) {
  let times = 0;
  const timer = window.setInterval(() => {
    DuduAjax.get({ url: API_WIPS_SYNC_PROGRESS }, { requestUuid }, false, false)
      .then((progress: any) => {
        if (progress && progress.finished) {
          window.clearInterval(timer);
          showSuccess("详情补全完成");
          emit("refresh");
        } else if (++times >= 30) {
          window.clearInterval(timer);
          showWarning("详情补全仍在进行,可稍后刷新查看");
        }
      })
      .catch(() => {
        window.clearInterval(timer);
      });
  }, 2000);
}

function fetchWipsDetails() {
  DuduAjax.post({ url: API_BIS_PATENT_FETCH_WIPS_DETAILS, path: { projectId } }, { patentId: props.patent.id }).then(
    (data: any) => {
      if (!data || !data.requestUuid) {
        showWarning("详情补全任务提交失败");
        return;
      }
      showSuccess("详情补全任务已提交,正在后台同步");
      pollDetailProgress(data.requestUuid);
    }
  );
}

function openCnipaLink() {
  if (isEmptyOrWhiteSpace(props.patent.pubNo)) {
    showWarning("目前只支持查看已公开专利");
    return;
  }
  window.open("http://epub.cnipa.gov.cn/patent/" + props.patent.pubNo);
}

function openEspacenetLink() {
  if (isEmptyOrWhiteSpace(props.patent.pubNo)) {
    showWarning("目前只支持查看已公开专利");
    return;
  }
  window.open(
    "https://worldwide.espacenet.com/publicationDetails/biblio?CC=" +
      props.patent.pubNo.substring(0, 2) +
      "&NR=" +
      props.patent.pubNo.substring(2) +
      "&FT=D&locale=cn_EP"
  );
}

return { __sfc: true,props, emit, store, projectId, pollDetailProgress, fetchWipsDetails, openCnipaLink, openEspacenetLink }
}

})